(() => {
  const root = document.querySelector('[data-tcg-product-set-siblings]');
  if (!root) return;

  const hub = window.Kl24PokemonHub;
  if (!hub) return;

  const grid = root.querySelector('[data-set-siblings-grid]');
  const gapLink = root.querySelector('[data-set-siblings-gap-link]');
  const countEl = root.querySelector('[data-set-siblings-count]');
  const feedbackEl = root.querySelector('[data-set-siblings-feedback]');

  const productId = Number.parseInt(root.dataset.productId || '0', 10) || 0;
  const setCode = String(root.dataset.setCode || '').trim().toUpperCase();
  const setName = String(root.dataset.setName || '').trim();
  const collectionHandle = root.dataset.collectionHandle || 'pokemon-singles';
  const limit = Math.max(4, Number.parseInt(root.dataset.productsToShow || '8', 10) || 8);
  const minProducts = Math.max(1, Number.parseInt(root.dataset.minProducts || '2', 10) || 2);
  const hideRelatedMin = Math.max(1, Number.parseInt(root.dataset.hideRelatedMin || '4', 10) || 4);
  const setsIndexUrl = root.dataset.setsIndex || '';
  const highlightsAsset = root.dataset.highlightsAsset || '';
  const gapBaseUrl = root.dataset.gapBaseUrl || '/pages/gap-filler';

  const PM_SKU_FULL = /^PM-([A-Z0-9]+)-(\d+)-(\d+)-([A-Z]{2,4})(?:-(?:RH|H|STD))?(?:-EN)?$/i;
  const PM_SKU_PREFIX = /^PM-([A-Z0-9]+)-(\d+)-(\d+)-/i;
  const CARD_NUM_RE = /(\d+)\s*\/\s*(\d+)/;

  const CONDITION_LABELS = {
    NM: 'Near Mint',
    EX: 'Excellent',
    LP: 'Lightly Played',
    MP: 'Moderately Played',
    DMG: 'Damaged',
  };

  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = String(html || '');
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  };

  const parseTitle = (title) => {
    const raw = String(title || '').trim();
    const match = CARD_NUM_RE.exec(raw);
    const cardNumber = match ? `${Number.parseInt(match[1], 10)}/${match[2]}` : '';
    const cardName = raw.split('–')[0]?.trim() || raw.split('-')[0]?.trim() || raw;
    return { cardName, cardNumber };
  };

  const parseFromSku = (sku) => {
    const raw = String(sku || '').trim().toUpperCase();
    if (!raw) return null;

    let match = PM_SKU_FULL.exec(raw);
    if (match) {
      return {
        setCode: match[1],
        cardNumber: `${Number.parseInt(match[2], 10)}/${match[3]}`,
        condition: String(match[4] || 'NM').toUpperCase(),
      };
    }

    match = PM_SKU_PREFIX.exec(raw);
    if (match) {
      return {
        setCode: match[1],
        cardNumber: `${Number.parseInt(match[2], 10)}/${match[3]}`,
        condition: 'NM',
      };
    }

    return null;
  };

  const parseFinishFromTags = (tags) => {
    const lower = (tags || []).map((t) => String(t).toLowerCase().trim());
    if (lower.some((tag) => tag.includes('reverse'))) return 'Reverse Holo';
    if (lower.some((tag) => tag === 'matt' || tag === 'normal' || tag === 'non-holo' || tag === 'non holo')) {
      return 'Matt (Normal)';
    }
    if (lower.some((tag) => tag.includes('holo') || tag.includes('foil') || tag === 'glitzer')) {
      return 'Holo';
    }
    if (
      lower.some(
        (tag) =>
          tag === 'standard' ||
          tag === 'standard print' ||
          tag === 'secret / standard' ||
          tag.includes('secret rare') ||
          (tag.includes('secret') && !tag.includes('reverse'))
      )
    ) {
      return 'Secret / Standard';
    }
    return 'Matt (Normal)';
  };

  const parseLanguageChip = (tags, sku) => {
    const lower = (tags || []).map((tag) => String(tag).toLowerCase().trim());
    if (
      String(sku || '').toUpperCase().endsWith('-EN') ||
      lower.some((tag) => tag === 'englisch' || tag === 'english' || tag === 'en')
    ) {
      return { label: 'EN', modifier: 'en' };
    }
    if (lower.some((tag) => tag === 'deutsch' || tag === 'german' || tag === 'de')) {
      return { label: 'DE', modifier: 'de' };
    }
    return null;
  };

  const parseFinishFromSku = (sku) => {
    const raw = String(sku || '').trim().toUpperCase().replace(/-EN$/, '');
    if (raw.endsWith('-RH')) return 'Reverse Holo';
    if (raw.endsWith('-STD')) return 'Secret / Standard';
    if (raw.endsWith('-H')) return 'Holo';
    return '';
  };

  const parseFinishFromDescription = (bodyHtml) => {
    const plain = stripHtml(bodyHtml);
    if (!plain) return '';
    const foilMatch = plain.match(
      /\bFoil:\s*(Reverse\s+Holo|Secret\s*\/\s*Standard|Non[\s-]*Holo|Holo\s*\/\s*Foil|Holo|Standard|Matt)/i
    );
    if (!foilMatch) return '';
    const value = foilMatch[1].toLowerCase().replace(/\s+/g, ' ').trim();
    if (value.includes('reverse')) return 'Reverse Holo';
    if (value.includes('secret')) return 'Secret / Standard';
    if (value.includes('non') && value.includes('holo')) return 'Matt (Normal)';
    if (value === 'matt' || value === 'standard') return 'Matt (Normal)';
    if (value.includes('holo') || value.includes('foil')) return 'Holo';
    return 'Matt (Normal)';
  };

  const resolveProductFinish = (tags, sku, bodyHtml) => {
    const fromSku = parseFinishFromSku(sku);
    if (fromSku) return fromSku;
    const fromTags = parseFinishFromTags(tags);
    if (fromTags !== 'Matt (Normal)') return fromTags;
    const fromBody = parseFinishFromDescription(bodyHtml);
    if (fromBody) return fromBody;
    return 'Matt (Normal)';
  };

  const finishLabelForCard = (finish) => {
    const key = String(finish || '').trim();
    if (!key) return '';
    if (key === 'Matt (Normal)') return 'Matt';
    return key;
  };

  const formatCardNumberWithFinish = (cardNumber, finish) => {
    const num = String(cardNumber || '').trim();
    const label = finishLabelForCard(finish);
    if (!num) return label;
    if (!label) return num;
    return `${num} · ${label}`;
  };

  const isOwnListingPhoto = (url) => {
    const raw = String(url || '').trim().toLowerCase();
    if (!raw) return false;
    if (raw.includes('assets.tcgdex.net') || raw.includes('api.tcgdex.net')) return false;
    return raw.includes('cdn.shopify.com');
  };

  const cardSortKey = (sku) => {
    const parsed = parseFromSku(sku);
    if (!parsed?.cardNumber) return Number.MAX_SAFE_INTEGER;
    const [left, right] = parsed.cardNumber.split('/');
    const num = Number.parseInt(left, 10);
    const total = Number.parseInt(right, 10);
    return Number.isFinite(num) ? num * 1000 + (Number.isFinite(total) ? total : 0) : Number.MAX_SAFE_INTEGER;
  };

  const showFeedback = (message, type) => {
    if (!feedbackEl) return;
    feedbackEl.hidden = false;
    feedbackEl.textContent = message;
    feedbackEl.classList.toggle('is-error', type === 'error');
    feedbackEl.classList.toggle('is-success', type === 'success');
  };

  const resolveSetHandle = async () => {
    if (!setsIndexUrl || !setCode) return null;
    try {
      const res = await fetch(setsIndexUrl);
      if (!res.ok) return null;
      const data = await res.json();
      const match = (data.sets || []).find(
        (entry) => String(entry.set_code || '').trim().toUpperCase() === setCode
      );
      return match?.handle ? String(match.handle) : null;
    } catch {
      return null;
    }
  };

  const productMatchesSet = (product, skuCode) => {
    const pm = String(skuCode || '').match(PM_SKU_PREFIX);
    if (pm && pm[1].toUpperCase() === setCode) return true;
    const tags = (product.tags || []).map((tag) => String(tag).trim().toLowerCase());
    return tags.includes(setCode.toLowerCase());
  };

  const fetchSetSiblings = async () => {
    const items = [];
    let products = [];

    const catalog = window.Kl24SinglesCatalog;
    if (catalog?.fetchSinglesProducts) {
      const result = await catalog.fetchSinglesProducts({
        collectionHandle,
        maxPages: 12,
      });
      products = result.products || [];
    } else {
      const origin = window.location.origin;
      let page = 1;
      while (page <= 12) {
        const url = `${origin}/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=250&page=${page}`;
        const res = await fetch(url);
        if (!res.ok) break;
        const data = await res.json();
        const batch = data.products || [];
        if (!batch.length) break;
        products.push(...batch);
        if (batch.length < 250) break;
        page += 1;
      }
    }

    products.forEach((product) => {
        if (product.id === productId) return;
        const variant = (product.variants || []).find((v) => v.available) || null;
        if (!variant?.available) return;
        const sku = String(variant.sku || '').trim().toUpperCase();
        if (!productMatchesSet(product, sku)) return;

        const tags = Array.isArray(product.tags) ? product.tags : [];
        const fromSku = parseFromSku(sku);
        const parsed = parseTitle(product.title);
        const rawImageUrl = (product.images || [])[0]?.src || '';
        const imageUrl = isOwnListingPhoto(rawImageUrl) ? rawImageUrl : '';
        const price = Number.parseFloat(variant.price || '0');

        items.push({
          productId: product.id,
          url: `/products/${product.handle}`,
          variantId: variant.id != null ? String(variant.id) : null,
          imageUrl,
          cardName: parsed.cardName || product.title || 'Single',
          cardNumber: fromSku?.cardNumber || parsed.cardNumber,
          condition: fromSku?.condition || 'NM',
          finish: resolveProductFinish(tags, sku, product.body_html),
          languageChip: parseLanguageChip(tags, sku),
          priceCents: Number.isFinite(price) ? Math.round(price * 100) : 0,
          sku,
          sortKey: cardSortKey(sku),
        });
    });

    items.sort((a, b) => a.sortKey - b.sortKey || a.cardName.localeCompare(b.cardName, 'de'));
    return items.slice(0, limit);
  };

  const addToCart = async (variantId, title, sku) => {
    if (!variantId) return false;
    const reserveApi = window.Kl24InventoryReservation;
    try {
      let parsedState = null;
      if (typeof reserveApi?.isEnabled === 'function' && reserveApi.isEnabled()) {
        parsedState = await reserveApi.addCartItems([{ id: variantId, quantity: 1 }], {
          reserveEntries: [{ shopifyVariantId: variantId, sku, quantity: 1 }],
          openDrawer: false,
        });
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: ['cart-icon-bubble', 'cart-drawer'],
            sections_url: window.location.pathname,
          }),
        });
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.description || 'Warenkorb konnte nicht aktualisiert werden.');
        }
        parsedState = await response.json();
      }

      if (typeof reserveApi?.refreshCartChrome === 'function') {
        await reserveApi.refreshCartChrome(parsedState, {
          openDrawer: false,
          source: 'tcg-product-set-siblings',
        });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      showFeedback(`„${title}“ wurde in den Warenkorb gelegt.`, 'success');
      return true;
    } catch (error) {
      showFeedback(error.message || 'Fehler beim Hinzufügen.', 'error');
      return false;
    }
  };

  const renderConditionBadge = (code) => {
    const condition = String(code || 'NM').toUpperCase();
    const label = CONDITION_LABELS[condition] || condition;
    const overlay = document.createElement('div');
    overlay.className = 'tcg-product-set-siblings__condition tcg-condition-badge tcg-condition-badge--card-overlay';
    overlay.innerHTML = `
      <span class="tcg-condition-badge__pill tcg-condition-badge__pill--${condition.toLowerCase()}" aria-label="Zustand: ${label} (${condition})" role="status">
        <span class="tcg-condition-badge__code" aria-hidden="true">${condition}</span>
        <span class="tcg-condition-badge__label">${label}</span>
      </span>
    `;
    return overlay;
  };

  const createThumbPlaceholder = (item) => {
    const ph = document.createElement('div');
    ph.className = 'tcg-singles-shop__thumb-placeholder';
    ph.setAttribute('aria-hidden', 'true');
    const num = String(item.cardNumber || '').trim();
    if (num) {
      const numEl = document.createElement('span');
      numEl.className = 'tcg-singles-shop__thumb-placeholder-num';
      numEl.textContent = num;
      ph.append(numEl);
    } else {
      ph.textContent = 'Scan folgt';
    }
    return ph;
  };

  const renderCard = (item) => {
    const card = document.createElement('div');
    card.className = 'tcg-singles-shop__card tcg-product-set-siblings__card';
    card.setAttribute('role', 'listitem');
    card.setAttribute('data-set-sibling-card', '');

    const thumbWrap = document.createElement('div');
    thumbWrap.className = 'tcg-singles-shop__thumb-wrap tcg-product-set-siblings__thumb-wrap';

    const mediaLink = document.createElement('a');
    mediaLink.className = 'tcg-product-set-siblings__media-link';
    mediaLink.href = item.url;
    mediaLink.setAttribute('aria-label', `${item.cardName} – Details anzeigen`);

    if (item.imageUrl) {
      const thumb = document.createElement('img');
      thumb.className = 'tcg-singles-shop__thumb';
      const api = window.Kl24ShopifyImage;
      const sized = api?.sizedUrl(item.imageUrl, api.WIDTHS?.gridThumb ?? 480) || item.imageUrl;
      thumb.src = sized;
      if (api?.srcSet) {
        const set = api.srcSet(item.imageUrl, [
          api.WIDTHS?.gridThumbSm ?? 320,
          api.WIDTHS?.gridThumb ?? 480,
        ]);
        if (set) thumb.srcset = set;
      }
      thumb.alt = item.cardName;
      thumb.loading = 'lazy';
      thumb.decoding = 'async';
      thumb.width = 320;
      thumb.height = 448;
      thumb.addEventListener('error', () => {
        thumb.remove();
        if (!mediaLink.querySelector('.tcg-singles-shop__thumb-placeholder')) {
          mediaLink.append(createThumbPlaceholder(item));
        }
      });
      mediaLink.append(thumb);
    } else {
      mediaLink.append(createThumbPlaceholder(item));
    }
    thumbWrap.append(mediaLink);

    if (item.condition) {
      thumbWrap.append(renderConditionBadge(item.condition));
    }

    if (item.variantId) {
      const fab = document.createElement('button');
      fab.type = 'button';
      fab.className = 'tcg-singles-shop__card-cart-fab';
      fab.setAttribute('aria-label', `${item.cardName} in den Warenkorb`);
      fab.title = 'In den Warenkorb';
      fab.innerHTML = '<span class="tcg-singles-shop__card-cart-fab-icon" aria-hidden="true"></span>';
      fab.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        fab.disabled = true;
        await addToCart(item.variantId, item.cardName, item.sku);
        fab.disabled = false;
      });
      thumbWrap.append(fab);
    }

    card.append(thumbWrap);

    const body = document.createElement('div');
    body.className = 'tcg-singles-shop__card-body';

    const nameLink = document.createElement('a');
    nameLink.className = 'tcg-product-set-siblings__name-link';
    nameLink.href = item.url;
    const name = document.createElement('p');
    name.className = 'tcg-singles-shop__card-name';
    name.textContent = item.cardName;
    nameLink.append(name);
    body.append(nameLink);

    const numberLine = formatCardNumberWithFinish(item.cardNumber, item.finish);
    if (numberLine) {
      const setLine = document.createElement('p');
      setLine.className = 'tcg-singles-shop__card-set';
      const numberEl = document.createElement('span');
      numberEl.className = 'tcg-singles-shop__set-number';
      numberEl.textContent = numberLine;
      setLine.append(numberEl);
      body.append(setLine);
    }

    if (item.languageChip) {
      const langEl = document.createElement('span');
      langEl.className = `tcg-singles-shop__lang tcg-singles-shop__lang--${item.languageChip.modifier}`;
      langEl.textContent = item.languageChip.label;
      body.append(langEl);
    }

    if (item.priceCents > 0) {
      const priceValue = document.createElement('p');
      priceValue.className = 'tcg-singles-shop__card-price tcg-product-set-siblings__price';
      priceValue.textContent = hub.formatMoney(item.priceCents);
      body.append(priceValue);
    }

    card.append(body);
    return card;
  };

  const hideRelatedProducts = () => {
    const relatedSection = document.querySelector('product-recommendations.related-products')?.closest('.shopify-section');
    if (relatedSection) relatedSection.hidden = true;
  };

  const applyGapCta = async (setHandle, itemCount, totalAvailable) => {
    if (!gapLink) return;

    if (setHandle) {
      const base = gapBaseUrl.split('?')[0];
      gapLink.href = `${base}?set=${encodeURIComponent(setHandle)}`;
    }

    let stockLabel = `${totalAvailable} Karten aus diesem Set verfügbar`;
    if (highlightsAsset && setHandle) {
      const highlights = await hub.fetchHighlights(highlightsAsset);
      const entry = (highlights?.top_gap_sets || []).find((set) => set.handle === setHandle);
      const count = Number(entry?.in_stock_count) || 0;
      if (count > 0) {
        stockLabel = `${count} Karten aus diesem Set auf Lager`;
      }
    }

    if (countEl && !countEl.textContent) {
      countEl.textContent = stockLabel;
      countEl.hidden = false;
    }

    gapLink.hidden = false;
  };

  (async () => {
    if (!setCode) {
      root.hidden = true;
      return;
    }

    const [items, setHandle] = await Promise.all([fetchSetSiblings(), resolveSetHandle()]);

    if (!grid || items.length < minProducts) {
      root.hidden = true;
      return;
    }

    root.hidden = false;

    const shown = items.slice(0, limit);
    const totalAvailable = items.length;

    if (countEl) {
      countEl.textContent = `${totalAvailable} weitere Karten aus „${setName || setCode}“ verfügbar`;
      countEl.hidden = false;
    }

    await applyGapCta(setHandle, shown.length, totalAvailable);

    grid.replaceChildren();
    grid.classList.toggle('is-partial-row', shown.length > 0 && shown.length < 4);
    shown.forEach((item) => grid.append(renderCard(item)));

    if (shown.length >= hideRelatedMin) {
      hideRelatedProducts();
    }
  })();
})();
